import { Popover, Transition } from '@headlessui/react';
import { GQLProductColourFragment } from '@theprintbar/graphql';
import React from 'react';

interface ColourDropdownProps {
	colours: GQLProductColourFragment[];
	realMax: number;
	customClick?: () => void;
	children: React.ReactNode;
}

export const ColourDropdown = ({ colours, realMax, customClick, children }: ColourDropdownProps) => {
	return (
		<Popover className="relative hidden lg:block">
			<Popover.Button
				onClick={customClick}
				className="w-[26px] h-[26px] lg:w-[30px] lg:h-[30px] flex justify-center items-center rounded-full bg-transparent  border border-grey focus:outline-none"
			>
				<p className="text-xs text-grey">+{colours.length - realMax}</p>
			</Popover.Button>

			<Transition
				enter="transition-opacity duration-100"
				enterFrom="opacity-0"
				enterTo="opacity-100"
				leave="transition-opacity duration-100"
				leaveFrom="opacity-100"
				leaveTo="opacity-0"
			>
				<Popover.Panel className="absolute z-20 bottom-12 -right-4">{children}</Popover.Panel>
			</Transition>
		</Popover>
	);
};
